import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import { PaginateQuery } from "../../interfaces";

export const supplicationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSupplications: builder.query<any, PaginateQuery>({
      query: (data) => ({
        url: buildPaginationQueryString(data, "/api/supplication"),
      }),
      providesTags: ["Supplications"],
    }),
    getSupplication: builder.query<any, string>({
      query: (id) => ({
        url: `/api/supplication/${id}`,
      }),
      providesTags: ["Supplication"],
    }),
    addSupplication: builder.mutation<any, any>({
      query: (data) => ({
        url: "/api/supplication",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Supplications", "Supplication"],
    }),
    updateSupplication: builder.mutation<any, { id: string; data: any }>({
      query: ({ id, data }) => ({
        url: `/api/supplication/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Supplications", "Supplication"],
    }),
    deleteSupplication: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/supplication/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Supplications"],
    }),
  }),
});

export const {
  useLazyGetSupplicationsQuery,
  useGetSupplicationQuery,
  useAddSupplicationMutation,
  useUpdateSupplicationMutation,
  useDeleteSupplicationMutation,
  useLazyGetSupplicationQuery,
} = supplicationApi;
